import "../App.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Warning from "../components/Warning";
import React, { useEffect, useState, useRef } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";

const ImageWithPlaceholder = ({ src, alt }) => {
  const [loaded, setLoaded] = useState(false);
  return (
    <div style={{ position: "relative", width: "120px", height: "120px" }}>
      {!loaded && <div className="imageLoader uuid-img-placeholder" />}
      <img
        src={src}
        alt={alt}
        className="uuid-entry-img"
        onLoad={() => setLoaded(true)}
        style={{ opacity: loaded ? 1 : 0, transition: "opacity 0.3s ease" }}
      />
    </div>
  );
};

const Photo = () => {
  const [DataHed, setDataHed] = useState("Loading");
  const [DataIncT] = useState("...");
  const [entries, setEntries] = useState([]);
  const hasFetched = useRef(false); // prevents Strict Mode double-fire

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;

    const run = async () => {
      try {
        const queryParameters = new URLSearchParams(window.location.search);
        const id = queryParameters.get("uuid");
        const response = await fetch("https://api.csfrederick.com/uuid/" + id, { mode: "cors" });
        const data = await response.json();

        let count = 0;
        for (let i = 0; i < data.length; i++) {
          const value = data[i];
          setDataHed("Loading " + (i + 1) + " of " + data.length + "…");
          const tempD = await fetch("https://api.csfrederick.com/data/" + value[0], { mode: "cors" });
          const tempData = await tempD.json();
          count++;
          setEntries(prev => [...prev, {
            id: value[0],
            header: tempData[value[0]]["headerData"],
            includes: tempData[value[0]]["includes"],
            timeDate: tempData[value[0]]["timeDate"],
            location: tempData[value[0]]["location"],
            format: tempData[value[0]]["format"],
          }]);
        }

        setDataHed(count + " item" + (count !== 1 ? "s" : "") + " found");
      } catch (err) {
        setDataHed("Nothing found");
      }
    };

    run();
  }, []);

  var shown = true;
  const queryParameters = new URLSearchParams(window.location.search);
  const id = queryParameters.get("uuid");
  const [updateData, setUpdate] = useState(
    "Keep your user ID safe, as anyone with it can view this page. Click to reveal."
  );

  function handleClick() {
    if (shown) {
      setUpdate("Keep your user ID safe, as anyone with it can view this page. Your ID is: " + id + ".");
      shown = false;
    } else {
      setUpdate("Keep your user ID safe, as anyone with it can view this page. Click to reveal.");
      shown = true;
    }
  }

  return (
    <div className="App" style={{ margin: "-8px" }}>
      <HelmetProvider>
        <Helmet>
          <title>Polaroid of {DataIncT}</title>
          <meta
            name="Polaroid Timeline"
            content="A canvas of just you, and some friends."
            description="A canvas of just you, and some friends."
            author="Jack Frederick"
          />
        </Helmet>
      </HelmetProvider>

      <Warning />
      <Navbar />

      <header className="Home">
        <div className="photoSpacer" />
        <div className="screenBox">

          <p className="Homethick uuid-enter-title">{DataHed}</p>

          <div className="uuid-entry-list">
            {entries.map((entry) => {
              const metaRows = [
                { label: "Includes", value: entry.includes },
                { label: "Taken on", value: entry.timeDate },
                { label: "Location", value: entry.location },
                { label: "Format",   value: entry.format },
              ].filter(r => r.value && r.value !== "undefined" && r.value.trim() !== "");

              return (
                <a
                  key={entry.id}
                  href={"/photo?id=" + entry.id}
                  className="uuid-entry-card uuid-entry-animate"
                >
                  <div className="uuid-entry-img-wrap">
                    <ImageWithPlaceholder
                      src={"https://api.csfrederick.com/image/" + entry.id}
                      alt={entry.header}
                    />
                  </div>

                  <div className="uuid-entry-data">
                    <span className="uuid-entry-title">{entry.header}</span>
                    <div className="photo-meta-grid uuid-meta-grid">
                      {metaRows.map(({ label, value }) => (
                        <React.Fragment key={label}>
                          <span className="photo-meta-label">{label}</span>
                          <span className="photo-meta-value">{value}</span>
                        </React.Fragment>
                      ))}
                    </div>
                  </div>
                </a>
              );
            })}
          </div>

          <div className="photoSpacer" />
        </div>

        <br />

        <p className="Homesmall uuid-enter-footer">
          Images are not available without the picture's ID or the physical image tag.
        </p>
        <p
          className="Homesmall uuid-enter-footer"
          onClick={handleClick}
          style={{ cursor: "pointer", opacity: 0.7, transition: "opacity 0.2s ease", animationDelay: "0.75s" }}
        >
          {updateData}
        </p>
        <p className="Homemini uuid-enter-footer" style={{ animationDelay: "0.85s" }}>
          If you have any concerns with your picture or if there is incorrect
          data shown above, contact me to get it resolved.
        </p>

        <div className="photoSpacer" />
      </header>

      <div className="photoSpacer" />
      <Footer />
    </div>
  );
};

export default Photo;